
    import { Component, Vue, Prop } from "vue-property-decorator";
    @Component({})
    export default class ServiceLink extends Vue {
        @Prop({ default: '' }) public readonly icon!: string;
        @Prop({ default: '' }) public readonly link!: string;
        @Prop({ default: '' }) public readonly title!: string;
        @Prop({default: false}) public readonly isActive!: boolean;

        get iconSrc(): string {
            try {
                // Webpack will bundle files matched by this context require
                return require(`@/assets/images/services/${this.icon}.svg`);
            } catch (e) {
                try {
                    return require('@/assets/images/services/icon-dexid.svg');
                } catch (_) {
                    return '';
                }
            }
        }

        get isInternal(): boolean {
            const l = this.link || '';
            // Internal if it doesn't start with a protocol (http/https) or protocol-relative (//), mailto, or tel
            return !/^(https?:)?\/\//i.test(l) && !l.startsWith('mailto:') && !l.startsWith('tel:');
        }
    }
